import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from './alert-dialog';
import { useNavigationGuard } from '../../hooks/useNavigationGuard';

export interface NavigationGuardProps {
    when: boolean;
    title?: string;
    description?: string;
    confirmLabel?: string;
    cancelLabel?: string;
}

export function NavigationGuard({
    when,
    title = 'Unsaved Changes',
    description = 'You have unsaved changes. Are you sure you want to leave this page?',
    confirmLabel = 'Leave Page',
    cancelLabel = 'Stay',
}: NavigationGuardProps) {
    const { isBlocked, confirm, cancel } = useNavigationGuard({ when });

    return (
        <AlertDialog open={isBlocked} onOpenChange={(open) => !open && cancel()}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                    <AlertDialogDescription>{description}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={cancel}>
                        {cancelLabel}
                    </AlertDialogCancel>
                    <AlertDialogAction onClick={confirm}>
                        {confirmLabel}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
